import React from 'react';
import PropTypes from 'prop-types';

import { StyledBadge } from './style';

const Badge = ({
  type = 'primary',
  children,
  notification,
  active,
  color,
  backgroundColor,
  fontWeight,
  uppercase,
  onClick,
}) => (
  <StyledBadge
    onClick={onClick}
    className={`${type} ${notification ? 'has-notification' : ''} ${
      active ? 'active' : ''
    }`}
    style={{
      color: `${color}`,
      backgroundColor: `${backgroundColor}`,
      fontWeight: `${fontWeight}`,
      cursor: `${typeof onClick === 'function' ? 'pointer' : 'default'}`,
    }}
    uppercase={uppercase}
  >
    {children}
  </StyledBadge>
);

Badge.propTypes = {
  children: PropTypes.node,
  type: PropTypes.oneOf([
    'primary',
    'news',
    'counter',
    'white',
    'outline',
    'dashed',
    'expired',
  ]),
  notification: PropTypes.bool,
  active: PropTypes.bool,
  color: PropTypes.string,
  backgroundColor: PropTypes.string,
  fontWeight: PropTypes.string,
  uppercase: PropTypes.bool,
  onClick: PropTypes.func,
};

export default Badge;
